// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_n8-1";
export var rowFirst = "_n8-3";
export var rowLast = "_n8-5";
export var rowMiddle = "_n8-4";
export var ticketListScroll = "_n8-2";
export var ticketStack = "_n8-0";